// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__13LCW","title":"Images90_title__2GKIs","images":"Images90_images__3DFuX"};